// A helper function to fetch Scenario Data
import { useAPI } from "/src/hooks/useAPI";

export async function fetchScenario(brand, authToken, scenario_id) {
    const {callAPI} = useAPI();
    try {
        const response = await callAPI(`scenario?scenario_id=${scenario_id}`, {
            token: authToken,
        });

        return response;
    } catch (err) {
        console.error('Error fetching scenario:', err.message);
        return null;
    }
}
